import { gql } from '@apollo/client'
import { get } from 'lodash/fp'
import getConfig from 'next/config'

export const GET_AUTH_IS_LOGGED_IN = gql`
  query getAuthIsLoggedIn {
    isLoggedIn
  }
`

function deleteCookie(name: string) {
  document.cookie = name + '=; Max-Age=-99999999;'
}

function forceLogout(ctx) {
  const { publicRuntimeConfig } = getConfig()
  if (typeof window === 'undefined' && typeof ctx.res !== 'undefined') {
    ctx.res.clearCookie(publicRuntimeConfig.accessTokenKey)
    ctx.res.clearCookie(publicRuntimeConfig.accessTokenKey, { path: '/' })
    ctx.res.clearCookie('_sneakers_session', { path: '/' })
    ctx.res.clearCookie('user.id', { path: '/' })
    ctx.res.clearCookie('user.expires_at', { path: '/' })
  } else {
    deleteCookie('_sneakers_session')
    deleteCookie(publicRuntimeConfig.accessTokenKey)
  }
}

// HoC for Page level components that will check the /me endpoint if a user is authenticated
//   if not, we clear the users cookies to force a logout.
// Scenarios:
//   If user is logged in AND they are not flagged by fraud they are allowed to proceed
//   If user is logged out they must be logged in since this is a protected route, cookies
//     are probably cleared already but do it again just in case
//   If user is flagged by fraud this will cause the query to /me returning a 401 which will
//     take them to the catch block and force log them out and clear their cookies
const withAuth = WrappedComponent => {
  const Component = props => <WrappedComponent {...props} />

  Component.getInitialProps = async context => {
    const { ctx, apolloClient } = context
    let appProps
    if (WrappedComponent.getInitialProps) {
      appProps = await WrappedComponent.getInitialProps(context)
    }

    try {
      const { data } = await apolloClient.query({
        query: GET_AUTH_IS_LOGGED_IN,
      })

      const isLoggedIn = get('isLoggedIn')(data)
      if (!isLoggedIn) {
        forceLogout(ctx)
      }
    } catch (error) {
      if (error && error.graphQLErrors) {
        error.graphQLErrors.forEach(graphQLError => {
          const errorCode = get('extensions.code')(graphQLError)
          if (errorCode === 'UNAUTHENTICATED') {
            forceLogout(ctx)
          }
        })
      }
    }

    return { ...appProps }
  }

  return Component
}

export default withAuth
